import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './artgallery/Header';
import Footer from './artgallery/Footer';
import Home from './artgallery/Home';
import Catalogue from './artgallery/Catalogue';
import Editorial from './artgallery/Editorial';
import Visit from './artgallery/Visit';

export default function ArtGalleryTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F4F1EA]" data-testid="art-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`art-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'catalogue' && <Catalogue setPage={setPage} />}
          {page === 'editorial' && <Editorial setPage={setPage} />}
          {page === 'visit' && <Visit setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
